<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
    <Loading></Loading>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  name: "App",
  components: { Loading },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}
/**设置背景颜色*/
body {
  margin: 0;
  height: 100%;

  background-color: #f1f2f2;
}

/* 设置vant-collapse-item__title 全局背景色 */
.van-collapse-item__title--expanded {
  /* background: #005ff9; */
  /* background-color: #009faf; */
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue